<div class="auditoria-header">
  <div class="auditoria-header__accent"></div>
  <div class="container auditoria-header__inner">
    <span class="material-icons auditoria-header__icon">how_to_reg</span>
    <div>
      <h1 class="auditoria-header__title">Auditoría · <span>Inscripciones</span></h1>
      <p class="auditoria-header__subtitle">Trazabilidad del flujo de inscripción O.S.</p>
    </div>
  </div>
</div>

<app-spinner
    [show]="!flagLoaded"
    [type]="'fullscreen'"
    [size]="'large'"
    [color]="'#B1476A'"
    [trackColor]="'#4CA7C8'"
    [text]="'Cargando auditoría de inscripciones...'"
    [showText]="true"
    [blurBackground]="true">
</app-spinner>

<div *ngIf="!flagLoaded" style="height: 100vh;"></div>

<div *ngIf="flagLoaded" class="auditoria-area auditoria-animate-in">
  <div class="container">
    <div class="barra-superior">
      <button mat-stroked-button class="btn-volver" (click)="volver()">
        <mat-icon>arrow_back</mat-icon> Volver
      </button>
    </div>

    <mat-form-field class="buscador" appearance="outline">
      <mat-label>Buscar en inscripciones</mat-label>
      <span class="material-icons" matPrefix>search</span>
      <input
        matInput
        [ngModel]="termino"
        (ngModelChange)="aplicarFiltro($event)"
        placeholder="Usuario, email, solicitud, paso, error..."
        autocomplete="off"
      />
    </mat-form-field>

    <div class="mat-elevation-z8 tabla-wrapper">
      <table mat-table [dataSource]="dataSource" matSort>

        <!-- usuario -->
        <ng-container matColumnDef="usuario">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Usuario </th>
          <td mat-cell *matCellDef="let g">
            <div class="usuario">
              <strong>{{ g.nombre || g.email || '-' }}</strong>
              <small>{{ g.email }}</small>
            </div>
          </td>
        </ng-container>

        <!-- trámite -->
        <ng-container matColumnDef="solicitud">
          <th mat-header-cell *matHeaderCellDef> Trámite </th>
          <td mat-cell *matCellDef="let g">
            <span class="mono" *ngIf="g.solicitudId; else sinSolicitud">{{ g.solicitudId }}</span>
            <ng-template #sinSolicitud>-</ng-template>
          </td>
        </ng-container>

        <!-- pasos -->
        <ng-container matColumnDef="pasos">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Pasos </th>
          <td mat-cell *matCellDef="let g">{{ g.totalPasos }}</td>
        </ng-container>

        <!-- último paso -->
        <ng-container matColumnDef="ultimoPaso">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Último paso </th>
          <td mat-cell *matCellDef="let g">
            <span class="accion">
              <span class="material-icons">{{ iconoAccionInscripcion(g.ultimo.accion) }}</span>
              {{ labelAccionInscripcion(g.ultimo.accion) }}
            </span>
            <div class="resumen" *ngIf="resumenEvento(g.ultimo)">{{ resumenEvento(g.ultimo) }}</div>
          </td>
        </ng-container>

        <!-- resultado -->
        <ng-container matColumnDef="resultado">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Resultado </th>
          <td mat-cell *matCellDef="let g">
            <span class="chip" [ngClass]="g.resultado === 'ERROR' ? 'chip--error' : 'chip--ok'">
              {{ g.resultado }}
            </span>
          </td>
        </ng-container>

        <!-- fecha -->
        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha </th>
          <td mat-cell *matCellDef="let g"> {{ g.fecha | date: 'dd/MM/yyyy HH:mm' }} </td>
        </ng-container>

        <!-- acciones -->
        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef> Acciones </th>
          <td mat-cell *matCellDef="let g">
            <button mat-icon-button color="primary" title="Ver pasos del intento" (click)="verDetalle(g)">
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            No hay registros que coincidan con "{{ termino }}".
          </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Seleccionar página"></mat-paginator>
    </div>
  </div>
</div>
